<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 工具栏 -->
      <div class="topbar">
        <div>
          <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                    class="search-input" @keyup.enter.native="search()" clearable/>
          <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                     @click.stop="search()">
            搜索
          </el-button>

          <!-- <div style="padding-top: 20px;">
            <el-select v-model="curAuditedOption" @change="curAuditedOptionChange">
              <el-option :value="false" label="未认证"></el-option>
              <el-option :value="true" label="已认证"></el-option>
            </el-select>
          </div> -->

          <el-select v-if="userDataTypeOptions.length > 0" style="padding-left: 20px" v-model="curUserDataType" clearable @change="curUserDataTypeChange">
            <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddExpertDialog()">
          新增专家
        </el-button>
      </div>
      <!-- 内容 -->
      <el-table borde stripe ref="table" v-loading="loading" :data="allExpertList"
                :header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px"
                @row-click="toggleTable">
        <el-table-column type="expand" align="center">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="医院">
                <span>{{ props.row.hospital || "暂无数据" }}</span>
              </el-form-item>
              <el-form-item label="科室">
                <span>{{ props.row.medicalLab || "暂无数据" }}</span>
              </el-form-item>
              <el-form-item label="头衔">
                <span>{{ props.row.jobTitle || "暂无数据" }}</span>
              </el-form-item>
              <el-form-item label="职务">
                <span>{{ props.row.job || "暂无数据" }}</span>
              </el-form-item>
              <el-form-item label="擅长">
                <span>{{ props.row.goodAt || "暂无数据" }}</span>
              </el-form-item>
              <el-form-item label="简介">
                <span>{{ props.row.resume || "暂无数据" }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="ultraExpertId" width="100px" align="center"/>
        <el-table-column label="姓名" prop="name" min-width="300px" align="center">
          <template slot-scope="scope">
            {{ scope.row.firstName + scope.row.lastName }}
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobilePhone" width="200px" align="center"/>
        <el-table-column label="性别" width="100px" align="center">
          <template slot-scope="scope">
            {{ scope.row.sex | sexTransform }}
          </template>
        </el-table-column>
        <el-table-column label="等级" prop="Level" width="150px" align="center">
          <template slot-scope="scope">
            {{ scope.row.level | levelTransform }}
          </template>
        </el-table-column>
        <el-table-column v-if="userDataTypeOptions.length > 0" label="用户类型" prop="UserDataType" width="200px" align="center">
          <template slot-scope="scope">
            {{ scope.row.userDataType | userDataTypeTransform }}
          </template>
        </el-table-column>
        <el-table-column label="认证状态" prop="IsAudited" width="200px" align="center">
          <template slot-scope="scope">
            <el-tag size="medium" :type="scope.row.isAudited ? '' : 'danger'">
              {{ scope.row.isAudited ? "已认证" : "未认证" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250px" align="center">
          <template slot-scope="scope">
            <el-button size="small" :type="scope.row.isAudited ? 'warning' : 'success'"
                       @click.stop="setExpertStatus(scope.row)">
              {{ scope.row.isAudited ? "取消认证" : "通过认证" }}
            </el-button>
            <el-button size="small" type="primary" @click.stop="openEditExpertDialog(scope.row)">
              编辑
            </el-button>
            <el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
                       @click.stop="handleDeleteExpert(scope.row)">
              {{ scope.row.isDeleted ? '恢复' : '删除' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background layout="prev, pager, next" :total="totalCount" :page-size="pageSize"
                     :current-page="currentPage" @current-change="currentChange"/>
    </el-card>

    <!-- 新增专家 -->
    <el-dialog :title="addExpertDialogType === 'create' ? '新增专家' : '编辑专家'" :visible.sync="addExpertDialog"
               width="60%" :destroy-on-close="true">
      <el-form ref="addExpertFormRef" :model="addExpertForm" :rules="rules">
        <el-row v-if="addExpertDialogType === 'create'" :gutter="20">
          <el-col :span="8">
            <el-form-item label="检测用户" :label-width="formLabelWidth">
              <el-input v-model="checkUserValue"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="getUserInfo()">检 测</el-button>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="姓" prop="firstName" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.firstName" disabled autocomplete="off"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="名" prop="lastName" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.lastName" disabled autocomplete="off"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" :label-width="formLabelWidth">
              <el-select v-model="addExpertForm.sex" disabled placeholder="请选择" style="width: 100%">
                <el-option label="男" :value="0"/>
                <el-option label="女" :value="1"/>
                <el-option label="未知" :value="2"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="手机号" prop="mobilePhone" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.mobilePhone" autocomplete="off" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-if="userDataTypeOptions.length > 0" label="所属领域" :label-width="formLabelWidth">
              <el-select v-model="addExpertForm.userDataType" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value"
                           :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="医院" prop="hospital" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.hospital" maxlength="100" show-word-limit
                        autocomplete="off"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科室" prop="medicalLab" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.medicalLab" autocomplete="off" maxlength="50"
                        show-word-limit/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="头衔" prop="jobTitle" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.jobTitle" autocomplete="off" maxlength="50"
                        show-word-limit/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务" prop="job" :label-width="formLabelWidth">
              <el-input v-model.trim="addExpertForm.job" autocomplete="off" maxlength="50"
                        show-word-limit/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="级别" :label-width="formLabelWidth">
            <el-select v-model="addExpertForm.level">
              <el-option :value="0" label="一级"></el-option>
              <el-option :value="1" label="二级"></el-option>
              <el-option :value="2" label="三级"></el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="擅长" :label-width="formLabelWidth">
              <el-input v-model="addExpertForm.goodAt" maxlength="500" show-word-limit type="textarea"
                        :rows="3" autocomplete="off"/>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="简介" :label-width="formLabelWidth">
              <el-input v-model="addExpertForm.resume" maxlength="500" show-word-limit type="textarea"
                        :rows="3" autocomplete="off"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addExpertDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="handleCreateOrUpdateExpert()">
          确 定
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getAllExpertList,
  addExpert,
  deleteExpertOrBack,
  updateExpertInfo,
  getExpertInfo
} from "@/api/expertManagement";
import {
  handleRes
} from "@/utils/handleRes"
import {
  deepClone
} from "@/utils/index"
import {
  inspectUser,
} from "@/api/system/CSDocument/user";
import {
  isVaild
} from "@/utils/validate"
import {
  printObj
} from "@/utils/debug"
import {getUserType} from "@/utils/userutil";

export default {
  data() {
    return {
      userDataTypeOptions: [],
      curUserDataType: 0,
      loading: false, // 加载开关
      searchValue: "", // 搜索内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      allExpertList: [],
      curAuditedOption: "",
      formLabelWidth: "80px",
      addExpertDialog: false, // 新增专家对话框
      addExpertDialogType: "", //
      addExpertForm: {
        sex: 0,
        uiserDataType: 0,
      },
      rules: {
        // firstName: [{
        // 	required: true,
        // 	message: "请输入姓",
        // 	trigger: ["blur", "change"]
        // }, ],
        // lastName: [{
        // 	required: true,
        // 	message: "请输入名",
        // 	trigger: ["blur", "change"]
        // }, ],
        // mobilePhone: [{
        // 	required: true,
        // 	message: "请输入手机号",
        // 	trigger: ["blur", "change"],
        // }, ],
        // hospital: [{
        // 	required: true,
        // 	message: "请输入医院",
        // 	trigger: ["blur", "change"],
        // }, ],
        // medicalLab: [{
        // 	required: true,
        // 	message: "请输入科室",
        // 	trigger: ["blur", "change"],
        // }, ],
        // jobTitle: [{
        // 	required: true,
        // 	message: "请输入头衔",
        // 	trigger: ["blur", "change"],
        // }, ],
        // job: [{
        // 	required: true,
        // 	message: "请输入职务",
        // 	trigger: ["blur", "change"],
        // }, ],
      },
      checkUserValue: "",

    };
  },
  created() {
    this.userDataTypeOptions = getUserType()
    this.getAllExpertList();
  },
  methods: {
    curAuditedOptionChange() {
      this.search()
    },
    curUserDataTypeChange() {
      this.search()
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      this.getAllExpertList();
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getAllExpertList();
    },
    /**
     * 获取所有专家列表
     */
    getAllExpertList() {
      this.loading = true;
      const params = {
        sortName: "",
        sortOrder: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
        userDataType: this.curUserDataType
      };
      if (isVaild(this.curAuditedOption)) {
        // params.where = [{
        // 	"field": "isAudited",
        // 	"value": this.curAuditedOption,
        // 	"op": "equal"
        // }];
      }
      getAllExpertList(params).then((res) => {
        this.allExpertList = res.data.rows;
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
    /**
     * 展开表格
     */
    toggleTable(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    resetAddExpertForm() {
      this.addExpertForm = {
        sex: 0,
        uiserDataType: 0,
      }
    },
    /**
     * 打开新增专家对话框
     */
    openAddExpertDialog() {
      this.addExpertDialog = true;
      this.addExpertDialogType = 'create'
      this.resetAddExpertForm();
      this.$refs.addExpertFormRef.clearValidate()

    },
    openEditExpertDialog(entity) {
      this.addExpertDialog = true;
      this.addExpertDialogType = 'edit'
      this.addExpertForm = deepClone(entity)
      this.$refs.addExpertFormRef.clearValidate()
    },
    /**
     * 新增或编辑专家信息
     */
    handleCreateOrUpdateExpert() {
      this.$refs.addExpertFormRef.validate((valid) => {
        const data = deepClone(this.addExpertForm)
        // printObj(data)

        if (valid) {

          if (this.addExpertDialogType === 'create') {
            if (!isVaild(data.userID)) {
              this.$message.warning("先进行检测用户操作")
              return
            }
            data.createUserId = this.addExpertForm.userID
            addExpert(data).then(res => {
              handleRes(res, () => {
                this.addExpertDialog = false
                this.search()
              })
            })
          } else if (this.addExpertDialogType === "edit") {
            updateExpertInfo(data).then(res => {
              handleRes(res, () => {
                this.addExpertDialog = false
                this.getAllExpertList()
              })
            })
          }
        }
      })
    },
    /**
     * 查询用户信息
     */
    getUserInfo() {
      if (!this.checkUserValue) {
        this.$message.error("检测用户不能为空");
        return;
      }
      //检测用户是否存在
      inspectUser(this.checkUserValue).then(userRes => {
        handleRes(userRes, () => {
          if (userRes.data.status === 2) {
            //检测该用户是否已经申请专家
            getExpertInfo({
              account: userRes.data.user.userID
            }).then(expertRes => {
              handleRes(expertRes, () => {
                if (isVaild(expertRes.data)) {
                  this.$message.warning('该用户已经提交专家认证申请')
                } else {
                  let user = userRes.data.user
                  this.addExpertForm = deepClone(user)
                  this.$forceUpdate()
                }
              })
            })

          } else {
            this.$message.warning('找不到用户信息')
          }
        })
      })
    },
    /**
     * 设置专家认证
     */
    setExpertStatus(row) {
      const data = deepClone(row)
      data.isAudited = !data.isAudited
      updateExpertInfo(data).then((res) => {
        handleRes(res, () => {
          this.getAllExpertList();
        })
      })
    },
    /**
     * 删除专家
     */
    handleDeleteExpert(row) {
      const params = {
        ultraExpertId: row.ultraExpertId,
      };
      let status = row.isDeleted ? "恢复" : "删除"
      this.$confirm(`是否${status}该专家`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            deleteExpertOrBack(params).then((res) => {
              handleRes(res, () => {
                this.getAllExpertList();
              })

            });
          })
    },
  },
};
</script>

<style scoped lang="scss">
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
